"use strict";
/// <reference path="../../../Trillium.UI/TypeScript/Models/Website/MainNavigationViewModel.tsx"/>
/// <reference path="../../../Trillium.UI/TypeScript/Models/Website/LinkViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var LogoutButton_1 = __importDefault(require("./LogoutButton"));
var HeaderNav = /** @class */ (function (_super) {
    __extends(HeaderNav, _super);
    function HeaderNav() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderNav.prototype.render = function () {
        var _a, _b, _c;
        var portalUrl = this.props.UmbracoMemberLoggedIn ?
            React.createElement("li", { className: "nav-item" },
                React.createElement("a", { href: this.props.PortalUrl.Url, title: "Portal", className: 'nav-link' },
                    React.createElement("i", { className: "fa fa-home" })))
            : "";
        return (React.createElement("div", null,
            React.createElement("ul", { className: "nav nav-fill" }, (_a = this.props.MainNavigation) === null || _a === void 0 ? void 0 :
                _a.map(function (navItem, index) { return (React.createElement("li", { key: index, className: "nav-item" },
                    React.createElement("a", { href: navItem.Url, target: navItem.Target, title: navItem.Name, className: navItem.IsActive ? 'nav-link Active' : 'nav-link' }, navItem.Name))); }),
                portalUrl,
                React.createElement(LogoutButton_1.default, { loginLogoutUri: (_b = this.props.LoginLogoutUrl) === null || _b === void 0 ? void 0 : _b.Url, loginLogoutLabel: (_c = this.props.LoginLogoutUrl) === null || _c === void 0 ? void 0 : _c.Name, logonStatus: this.props.UmbracoMemberLoggedIn }))));
    };
    return HeaderNav;
}(React.Component));
exports.default = HeaderNav;
